import { Component,  OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Session } from 'src/app/interfaces/session-data';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-ozow-payment-method',
  templateUrl: './ozow.component.html',
  styleUrls: ['./ozow.component.scss']
})
export class OzowComponent implements OnInit {
  public link:string;
  private lock: boolean = false;
  private session:Session;
  constructor(
    private router:Router,
    private sessionService:SessionService,
    private route: ActivatedRoute
  ) {
    this.link = "ozow";
  }

  ngOnInit(): void {
    this.session = sessionStorage.getItem("sessionData")? JSON.parse(sessionStorage.getItem("sessionData")) : null;
    this.selectMethod();
    this.sessionService.getPaymentMethodListLock().subscribe((lock:boolean) => {
      this.lock = lock;
    });
  }

  toggleListView(){
    this.sessionService.emitPaymentMethodPromotion("ozow");
  }

  selectMethod(event?: Event){
    sessionStorage.setItem("selected-payment","eft_ozow");
    if(event!=undefined &&!this.lock){
      this.sessionService.setSelectedChargeAmount({
        currency:this.session.sessionDisplayInformation.currencyCode,
        amount:this.session.sessionDisplayInformation.amount
      });
      this.sessionService.setCurrencyCodeListLock(true);
      this.sessionService.emitSelectedPaymentMethod("ozow");
      this.router.navigate([this.link],{relativeTo: this.route});
    }
  }
}
